import React, { useEffect, useState } from "react";
import { addDays, format } from "date-fns";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ReferenceArea,
  ResponsiveContainer,
  ReferenceLine,
  XAxis,
  Legend,
  YAxis,
  Tooltip,
  Label,
} from "recharts";
import { formatNumber } from "../../../../utils/helper";
import ConfirmationDlg from "../../../../components/ConfirmationDlg";
import { matar } from "../../../../api";
import { downloadExcel } from "../../../../utils/exporter";
import { Card, CardBody } from "../../../../components/card/card";
import { useLocation, useNavigate } from "react-router-dom";
import { dataSensor } from "./data-sensor";
import { CardHeader } from "react-bootstrap";
import { assetData } from "../../data-sample";

const ChartDegradationOverview = ({ assetId, download }) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const [id, setId] = useState(null);
  const withSensor = params.get("withSensor") === "true";
  const [showModal, setShowModal] = useState(false);
  const [rul, setRul] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [rulVibration, setRulVibration] = useState(0);
  const [totalCostVibration, setTotalCostVibration] = useState(0);
  const [showSensor, setShowSensor] = useState(null);
  const [data, setData] = useState([]);
  useEffect(() => {
    if (download > 0) downloadExcel(data, "RUL");
  }, [download]);

  const [selected, setSelected] = useState(null);
  function changeToQuarter(val) {
    let date = new Date(val);
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let quarter = Math.ceil(month / 3);
    return "Q" + quarter + " " + year;
  }
  const getData = async () => {
    const result = await matar.calculateMatar({
      asset_id: assetId,
    });
    if (result.ok) {
      const body = await result.json();
      const data = body.data.simulation;
      let sensorData = null;
      if (withSensor) {
        sensorData = dataSensor[assetId];
        setShowSensor(true);
        if (sensorData) {
          const FData = sensorData.find((item) => item.Ref === "F");
          setRefFGina({
            days: FData.Year,
            score: 0,
          });
          const currentYear = new Date().getFullYear();
          const year = parseInt(FData.Year);
          const totalYear = year - currentYear;
          setRulVibration(totalYear);
          setTotalCostVibration(FData["Cumulative LCC"]);
        }
      }
      const dataFilter = data.map((item) => {
        let value_vibration = 0;
        if (sensorData) {
          const selected = sensorData.find((i) => i.Year == item.Year);
          if (selected) {
            value_vibration = selected["Smoothed Deterioration"];
          }
        }

        if (item.Year < 2025) {
          value_vibration = null;
        }

        return {
          days: item.Year,
          score: item.Year <= "2026" ? item["Smoothed Deterioration"] : null,
          score_2: item.Year >= "2025" ? item["Smoothed Deterioration"] : null,
          value_vibration: sensorData
            ? value_vibration
            : item["Smoothed Deterioration"],
          maintenance: item.Total_PM_Cost,
          annualize: item["Annualized LCC"],
          ref: item.Year == "2025" ? "C" : item.Ref,
        };
      });
      // get data with ref "F"
      const dataF = data.find((item) => item.Ref === "F");
      // RUL mean year from dataF minus current year
      if (dataF) {
        const currentYear = new Date().getFullYear();
        const year = parseInt(dataF.Year);
        const totalYear = year - currentYear;
        if (!sensorData) {
          setRulVibration(totalYear);
          setTotalCostVibration(dataF["Cumulative LCC"]);
        }
        setRul(totalYear);
        setTotalCost(dataF["Cumulative LCC"]);
      }

      setData(dataFilter);
    }
  };

  useEffect(() => {
    const ass = assetData.find((i) => i["Asset ID"] === assetId);
    console.log({ ass, assetData, assetId });
    if (ass) setId(ass.id);

    getData();
    // const dataFilter = dataRaw[assetId];
    //
    // const data = dataFilter.map((item) => {
    //   const { Quarter, ref } = item;
    //   const score = parseFloat(item["Health Indicator"]);
    //   const maintenance = parseFloat(item["Total Maintenance Cost"]);
    //   const ownership = parseFloat(item["Total Cost of Ownership"]);
    //   const annualize = parseFloat(item["Annualized Cost"]);
    //
    //   return {
    //     days: changeToQuarter(Quarter),
    //     score: Quarter <= "2025-05-01" ? score : null,
    //     score_2: Quarter >= "2025-04-01" ? score : null,
    //     maintenance,
    //     ownership,
    //     annualize,
    //     ref: ref,
    //   };
    // });
    // setData(data);
  }, [assetId]);

  const [refF, setRefF] = useState(null);
  const [refFGina, setRefFGina] = useState(null);
  const [refP, setRefP] = useState(null);
  const [refC, setRefC] = useState(null);
  useEffect(() => {
    const ref_f = data.find((i) => i.ref === "F");
    setRefF(ref_f);
    const ref_p = data.find((i) => i.ref === "P");
    setRefP(ref_p);
    const ref_c = data.find((i) => i.ref === "C");
    setRefC(ref_c);
  }, [data]);
  const formatTick = (tick) => {
    //convert days to month
    const month = Math.floor(tick / 30);
    return month;
    // return tick.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const formatAddDays = (tick) => {
    return format(new Date(tick), "dd/MM/yyyy");
  };
  const CustomLabelRed = ({ viewBox, value }) => {
    const { x, y } = viewBox;
    return (
      <>
        <circle
          onClick={showDetailPopupAlert}
          cx={x}
          cy={y - 5 * 0.05}
          r={5}
          fill="red"
          cursor={"pointer"}
        />
        <text
          onClick={showDetailPopupAlert}
          x={x}
          y={y - 10}
          fill="red"
          fontSize={13}
          textAnchor="left"
          cursor={"pointer"}
        >
          {value}
        </text>
      </>
    );
  };
  const CustomLabelPurple = ({ viewBox, value }) => {
    const { x, y } = viewBox;
    return (
      <>
        <circle
          onClick={showDetailPopupCritical}
          cx={x}
          cy={y - 5 * 0.05}
          r={5}
          fill="#7067ac"
          cursor={"pointer"}
        />
        <text
          onClick={showDetailPopupCritical}
          x={x}
          y={y - 10}
          fill="#7067ac"
          fontSize={13}
          textAnchor="left"
          cursor={"pointer"}
        >
          {value}
        </text>
      </>
    );
  };
  const navigate = useNavigate();
  const CustomLabelGreen = ({ viewBox, value }) => {
    const { x, y } = viewBox;
    return (
      <>
        <circle
          onClick={showDetailPopupCritical}
          cx={x}
          cy={y - 5 * 0.05}
          r={5}
          fill="#0b9814"
          cursor={"pointer"}
        />
        <text
          onClick={showDetailPopupCritical}
          x={x}
          y={y - 10}
          fill="#0b9814"
          fontSize={13}
          textAnchor="left"
          cursor={"pointer"}
        >
          {value}
        </text>
      </>
    );
  };
  const CustomLabelGrey = ({ viewBox, value }) => {
    const { x, y } = viewBox;
    return (
      <>
        <circle
          onClick={showCurrentCondition}
          cx={x}
          cy={y - 5 * 0.05}
          r={5}
          fill="grey"
          cursor={"pointer"}
        />
        <text
          onClick={showCurrentCondition}
          x={x}
          y={y - 10}
          fill="grey"
          fontSize={13}
          textAnchor="left"
          cursor={"pointer"}
        >
          {value}
        </text>
      </>
    );
  };

  const showDetailPopupCritical = () => {
    setShowModal(true);
    setSelected(refF);
  };
  const showDetailPopupAlert = () => {
    setShowModal(true);
    setSelected(refP);
  };
  const showCurrentCondition = () => {
    setShowModal(true);
    setSelected(refC);
  };

  return (
    <div className={"content row"}>
      <div className="col-md-9 col-sm-12">
        <div style={{ padding: "10px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              fontSize: 13,
              marginBottom: "10px",
              marginTop: "10px",
            }}
          >
            <div style={{ display: "flex", marginRight: "5px" }}>
              <div
                style={{
                  width: "15px",
                  borderBottom: "2px solid #03408a",
                  height: "9px",
                  marginRight: "5px",
                }}
              >
                {" "}
              </div>
              <div>Actual</div>
            </div>
            <div style={{ display: "flex", marginRight: "5px" }}>
              <div
                style={{
                  width: "15px",
                  borderBottom: "2px dashed #705138",
                  height: "9px",
                  marginRight: "5px",
                }}
              >
                {" "}
              </div>
              <div>Forecast</div>
            </div>
            {showSensor ? (
              <div style={{ display: "flex" }}>
                <div
                  style={{
                    width: "15px",
                    borderBottom: "2px dashed #0b9814",
                    height: "9px",
                    marginRight: "5px",
                  }}
                >
                  {" "}
                </div>
                <div>GINA AI Prediction</div>
              </div>
            ) : null}
          </div>
          <ResponsiveContainer height={320}>
            <ConfirmationDlg
              open={showModal}
              onClose={() => {
                setShowModal(false);
              }}
              onSubmit={() => {
                setShowModal(false);
              }}
              title={"Forecast Cost"}
              hideCancelBtn={true}
              btnSubmitText={"Ok"}
            >
              Forecasted Maintenance Cost : <b>${selected?.maintenance}</b>{" "}
              <br />
              Health Score : <b>{selected?.score}</b> <br />
              Time : <b>${selected?.days}</b>
            </ConfirmationDlg>
            <AreaChart
              data={data}
              margin={{ top: 30, right: 30, left: 20, bottom: 30 }}
            >
              <defs>
                <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="1%" stopColor="#03408a" />
                  <stop offset="99%" stopColor="#065dc8" />
                </linearGradient>
                <linearGradient id="colorUv2" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="1%" stopColor="#0b9814" />
                  <stop offset="99%" stopColor="#0b9814" />
                </linearGradient>
                <linearGradient id="colorUv1" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="3%" stopColor="#705138" />
                  <stop offset="97%" stopColor="#705138" />
                </linearGradient>
              </defs>
              <XAxis
                type={"category"}
                tick={{ fill: "white" }}
                fontSize={13}
                tickCount={10}
                domain={[0, 4500]}
                dataKey={"days"}
              >
                <Label
                  fill={"white"}
                  fontSize={13}
                  value="Lifespan"
                  offset={-20}
                  position="insideBottom"
                />
              </XAxis>
              <YAxis dataKey={"score"} tick={{ fill: "white" }} fontSize={13}>
                <Label
                  fill={"white"}
                  fontSize={13}
                  value="Health Indicator"
                  angle={-90}
                  position="insideBottomLeft"
                />
              </YAxis>
              <Tooltip
                animationEasing={"ease-in-out"}
                content={({ active, label, payload }) => {
                  return active ? (
                    <div style={{ color: "white" }}>
                      {payload.map((row, index) => {
                        return (
                          <div
                            key={index}
                            className={
                              index !== payload.length - 1 ? "mb-1" : ""
                            }
                          >
                            <div
                              style={{
                                color: row.color,
                              }}
                            >
                              Date: {label} <br />
                              Score: {row.value}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : null;
                }}
                wrapperStyle={{
                  background: "rgba(255,255,255,0.8)",
                  borderRadius: 4,
                  padding: "5px 8px",
                  fontWeight: 500,
                  boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                }}
                cursor={false}
              />
              <CartesianGrid
                strokeDasharray="6 1 2"
                horizontal={false}
                strokeOpacity={0.2}
                stroke={"#E73145"}
              />
              {/*<ReferenceLine*/}
              {/*  height={50}*/}
              {/*  x={4000}*/}
              {/*  label={"oke"}*/}
              {/*  stroke={"#E73145"}*/}
              {/*  strokeWidth={2}*/}
              {/*></ReferenceLine>*/}

              <Area
                type="monotone"
                dataKey={"score"}
                stackId="2"
                strokeWidth={2}
                fillOpacity={0.7}
                stroke={"#03408a"}
                fill="url(#colorUv)"
              />
              <Area
                type="monotone"
                dataKey={"score_2"}
                strokeDasharray={"3 4"}
                stackId="1"
                strokeWidth={2}
                fillOpacity={0.7}
                stroke={"#ad550e"}
                fill="url(#colorUv1)"
              />

              {showSensor ? (
                <Area
                  type="monotone"
                  strokeDasharray={"3 4"}
                  dataKey={"value_vibration"}
                  stackId="3"
                  strokeWidth={2}
                  fillOpacity={0.2}
                  stroke={"#0b9814"}
                  fill="url(#colorUv2)"
                />
              ) : null}

              {refP ? (
                <>
                  <ReferenceLine
                    x={refP.days}
                    stroke="#E73145"
                    strokeDasharray="3 3"
                  ></ReferenceLine>
                  <ReferenceLine
                    y={refP.score}
                    stroke="#E73145"
                    strokeDasharray="3 3"
                  ></ReferenceLine>
                  <ReferenceArea
                    x1={refP.days}
                    x2={refP.days}
                    y1={0}
                    y2={refP.score || refP.score_2}
                    fill="red"
                    cursor={"pointer"}
                    onClick={showDetailPopupAlert}
                    strokeWidth={2}
                    fillOpacity={1}
                    stroke="#E73145"
                    label={<CustomLabelRed value={"Potential Failure (P)"} />}
                  ></ReferenceArea>
                </>
              ) : null}

              {refF ? (
                <>
                  <ReferenceLine
                    x={refF.days}
                    stroke="#7067ac"
                    strokeDasharray="3 3"
                  ></ReferenceLine>
                  <ReferenceLine
                    y={refF.score}
                    stroke="#7067ac"
                    strokeDasharray="3 3"
                  ></ReferenceLine>
                  <ReferenceArea
                    x1={refF.days}
                    x2={refF.days}
                    y1={0}
                    y2={refF.score || refF.score_2}
                    fill="red"
                    strokeWidth={2}
                    fillOpacity={1}
                    onClick={showDetailPopupCritical}
                    cursor={"pointer"}
                    stroke="#7067ac"
                    label={
                      <CustomLabelPurple value={"Functional Failure (F)"} />
                    }
                  ></ReferenceArea>
                </>
              ) : null}
              {refFGina ? (
                <>
                  <ReferenceLine
                    x={refFGina.days}
                    stroke="#0b9814"
                    strokeDasharray="3 3"
                  ></ReferenceLine>
                  <ReferenceArea
                    x1={refFGina.days}
                    x2={refFGina.days}
                    y1={0}
                    y2={0}
                    fill="red"
                    strokeWidth={2}
                    fillOpacity={1}
                    onClick={showDetailPopupCritical}
                    cursor={"pointer"}
                    stroke="#0b9814"
                    label={
                      <CustomLabelGreen value={"Functional Failure (F)"} />
                    }
                  ></ReferenceArea>
                </>
              ) : null}
              {refC ? (
                <>
                  <ReferenceLine
                    x={refC.days}
                    stroke="#7067ac"
                    strokeDasharray="3 3"
                  ></ReferenceLine>
                  <ReferenceLine
                    y={refC.score}
                    stroke="#7067ac"
                    strokeDasharray="3 3"
                  ></ReferenceLine>
                  <ReferenceArea
                    x1={refC.days}
                    x2={refC.days}
                    y1={0}
                    y2={refC.score}
                    fill="red"
                    cursor={"pointer"}
                    onClick={showCurrentCondition}
                    strokeWidth={2}
                    fillOpacity={1}
                    stroke="#a1a1a1"
                    label={<CustomLabelGrey value={"Current Condition"} />}
                  ></ReferenceArea>
                </>
              ) : null}
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="col-md-3 col-sm-12">
        <Card>
          <CardHeader>Based on Historical Data</CardHeader>
          <CardBody>
            RUL: <b>{rul} Years</b>
            <br />
            Cumulative LCC: <b>${formatNumber(totalCost)}</b>
          </CardBody>
        </Card>
        {showSensor ? (
          <div style={{ marginTop: "20px" }}>
            <Card className={"border-theme"}>
              <CardHeader>Based on Sensor Data</CardHeader>
              <CardBody>
                RUL: <b>{rulVibration} Years</b>
                <br />
                Cumulative LCC: <b>${formatNumber(totalCostVibration)}</b>
                <br />
                <div class="">
                  <button
                    className={"btn btn-sm btn-theme text-black my-1 w-100"}
                    onClick={() => {
                      navigate(`/machine/${id}`);
                    }}
                  >
                    View Machine Health
                  </button>

                  <button
                    onClick={() => {
                      navigate(`/sensor/live/${id}`);
                    }}
                    className={"btn btn-sm btn-theme text-black w-100"}
                  >
                    View Live Sensor Data
                  </button>
                </div>
              </CardBody>
            </Card>
          </div>
        ) : null}
      </div>
    </div>
  );
};
/* Todo data prop define */
export default ChartDegradationOverview;
